'use strict';

export default angular
  .module('maestro.filters.messageData', [])

  .filter('messageData', function(utils) {
    return function(message) {
      if (message.type == 1) {
        return anuglar.toJson(utils.getMessageData(message));
      } else {
        return '';
      }
    };
  })

  .name;
